export const data = [
    {
        id: 1,
        firstName: "toby",
        lastName: "alderweireld",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maxime deserunt, culpa ratione provident necessitatibus sed laudantium, itaque",
        image: "./resources/players/firstteam_tobyalderweireld.png",
        squadNumber: 4,

        stats: {
            position: "centre back",
            goals: 0,
            assists: 0,
            gamesPlayed: 33,
            minutesPlayed: 2958,
            passSuccess: 81.7,
        },
    },
    {
        id: 2,
        firstName: "harry",
        lastName: "kane",
        position: "striker",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maxime deserunt, culpa ratione provident necessitatibus sed laudantium, itaque",
        image: "./resources/players/firstteam_harrykane.png",
        squadNumber: 10,
        stats: {
            position: "striker",
            goals: 18,
            assists: 3,
            gamesPlayed: 29,
            minutesPlayed: 2589,
            passSuccess: 66.7,
        },
    },
    {
        id: 3,
        firstName: "heung-min",
        lastName: "son",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maxime deserunt, culpa ratione provident necessitatibus sed laudantium, itaque",
        image: "./resources/players/firstteam_heungminson.png",
        squadNumber: 7,
        stats: {
            position: "forward",
            goals: 11,
            assists: 10,
            gamesPlayed: 30,
            minutesPlayed: 2485,
            passSuccess: 84.7,
        },
    },
    {
        id: 4,
        firstName: "dane",
        lastName: "scarlett",
        position: "forward",
        text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maxime deserunt, culpa ratione provident necessitatibus sed laudantium, itaque",
        image: "./resources/players/u18_danescarlett.png",
        squadNumber: "",
        stats: {},
    },
];
